import { render, staticRenderFns } from "./ResultPage.vue?vue&type=template&id=66154245&scoped=true"
import script from "./ResultPage.vue?vue&type=script&lang=js"
export * from "./ResultPage.vue?vue&type=script&lang=js"
import style0 from "./ResultPage.vue?vue&type=style&index=0&id=66154245&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66154245",
  null
  
)

export default component.exports